<div class="space-y-6">
  <div *ngIf="section.name" class="flex items-center space-x-2 border-b border-slate-100 pb-2 mb-4">
    <div class="w-1 h-4 bg-teal-500 rounded-full"></div>
    <h3 class="text-xs font-bold text-slate-600 uppercase tracking-widest">
      {{ section.name }}
    </h3>
  </div>

  <div *ngFor="let row of section.rows; trackBy: trackRow" class="mb-4">
    <div class="grid grid-cols-12 gap-x-2 gap-y-3 items-start">
      <ng-container *ngFor="let field of row.fields; trackBy: trackField">

        <div [ngClass]="getFieldColSpan(row.fields.length)" class="col-span-12">

          <div *ngIf="getColumnsFor(field.name).length > 0; else normalField"
            class="col-span-12 border-l-4 border-teal-500 bg-slate-50 rounded-r-lg p-3 shadow-sm">
            <div class="flex items-center space-x-2 mb-2">
              <span class="text-[10px] font-bold text-slate-500 uppercase">Grid Details</span>
            </div>
            <div class="bg-white rounded border border-slate-200 overflow-hidden">
              <app-line-items-table [formArray]="getFormArray(field.name)" [columns]="getColumnsFor(field.name)"
                [config]="layout.fieldsMap[field.name]" [form]="form" [layout]="layout">
              </app-line-items-table>
            </div>
          </div>

          <ng-template #normalField>
            <div class="w-full">
              <app-dynamic-field [field]="field" [config]="layout.fieldsMap[field.name]" [form]="form" [row]="row"
                class="block w-full"></app-dynamic-field>
            </div>
          </ng-template>

        </div>
      </ng-container>
    </div>
  </div>
</div>